import React, { Component } from 'react'
import { connect } from 'react-redux'

import { push } from 'connected-react-router'

import PublishModal from './publish-modal'
import PageWrapper from '../../components/PageWrapper'
import NewLicenseHeader from './new-license-header'
import { AudienceSelector, SelectedAudience } from './audience-lists'
import LicensingErrorAlert from './error-alert'
import NewLicenseConfigHeader from './new-license-config-header'

import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'

import './styles.css'
import debounce from 'lodash/debounce'
import axios from 'axios'
import Alert from 'react-s-alert'
import SessionService from '../../lib/services/SessionService'

const CONFIG_AUDIENCE = 'CONFIG_AUDIENCE'
const CONFIG_PRODUCT = 'CONFIG_PRODUCT'

const CPM_COST_MULTIPLIER = 1000000

class License extends Component {
    state = {
        selected: null,
        phase: CONFIG_AUDIENCE,
        error: null,
        size: 10,
        offset: 0,
        filter: '',
        sort: 'audienceName',
        sortOrder: 'asc',
        hideModal: true,
        saving: false,
        status: '',
        statusMessage: '',
        audiences: []
    }

    onCancel = () => this.props.goBack()
    onGoConfigAudience = () => this.setState({ phase: CONFIG_AUDIENCE })
    onGoConfigProduct = () => this.setState({ phase: CONFIG_PRODUCT })

    onPublish = ({ dmp, dmpProductId, partnerId, licenseName, validUntil, currency, cpm, cookieDuration, countryId = null }) => {
        this.setState({ hideModal: false, saving: true }, () => {
            validUntil = moment(validUntil, 'DD.MM.YYYY').unix()
            this.saveLicense(
                this.state.selected.audienceId,
                this.state.selected.audienceName,
                dmp,
                dmpProductId,
                partnerId,
                licenseName,
                validUntil,
                Number(cpm),
                currency,
                cookieDuration,
                countryId,
            )
        })
    }
    onFailPublish = error => {
        this.setState({ error })
    }

    onHide() {
        this.setState({ hideModal: true, saving: false })
    }

    onFilterChange(target) {
        let offset = 0
        this.setState({ offset: offset, filter: target.value })
        this.debouncedFilter(target.value, this.state.size, offset, true)
    }
    onLoadMore() {
        let offset = this.state.offset + this.state.size
        this.setState({ offset: offset }, () => {
            this.debouncedFilter(this.state.filter, this.state.size, offset, false, this.state.sort, this.state.sortOrder)
        })
    }
    onSortChange(sortField) {
        let sort = this.state.sort
        let sortOrder = this.state.sortOrder
        if (sort != sortField) {
            sortOrder = 'asc'
        } else {
            // toggle if is the same field
            sortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
        }
        sort = sortField
        let offset = 0
        this.setState({ sort: sort, sortOrder: sortOrder, offset: offset })
        this.debouncedFilter(this.state.filter, this.state.size, offset, true, sort, sortOrder)
    }
    componentDidMount() {
        this.fetchAllAudiences(this.state.filter, this.state.size, this.state.offset, true)
        this.debouncedFilter = debounce(this.fetchAllAudiences, 300)
    }
    onSelect(audience) {
        this.setState({ selected: audience })
    }
    onFilterChange(target) {
        this.setState({ offset: 0, filter: target.value }, () => {
            this.debouncedFilter(target.value, this.state.size, this.state.offset, true, this.state.sort, this.state.sortOrder)
        })
    }

    fetchAudiences(filter = '', size = 20, offset = 0, clear = false, sort = 'audienceName', sortOrder = 'asc', showDeleted = false) {
        let query = `/audience?offset=${offset}&size=${size}&filter=${filter}&sort=${sort}&sortOrder=${sortOrder}&showDeleted=${showDeleted}`

        this.setState({ loading: true }, () => {
            axios.get(query).then(response => {
                let newAudiences = response.data.body
                let oldAudiences = []
                if (!clear) {
                    oldAudiences = this.state.audiences
                }
                oldAudiences = oldAudiences.concat(newAudiences)
                this.setState({ audiences: oldAudiences, loading: false })
            })
        })
    }

    fetchAllAudiences(filter = '', size = 20, offset = 0, clear = false, sort = 'creation', sortOrder = 'desc', showDeleted = false) {
        this.fetchAudiences(filter, size, offset, clear, sort, sortOrder, showDeleted)
    }

    saveLicense(audienceId, audienceName, dmp, dmpProductId, dmpClientId, licenseName, validUntil, cpmCost, currency, cookieDuration, countryId = null) {
        // 1- create link
        // confirm promise after upload notification
        
        cpmCost = cpmCost * CPM_COST_MULTIPLIER
        validUntil = validUntil * 1000

        let audiencelink = {
            audienceId: audienceId,
            dmp: dmp,
        }

        // adform require more stuff for an audience
        if(dmp === "adform"){
            try{
                let partnerLogged = SessionService.getPartnerLogged()

                audiencelink = {
                    audienceId: audienceId,
                    dmp: dmp,
                    cpmCost: cpmCost,
                    dmpClientId: dmpClientId,
                    cookieDuration: cookieDuration,
                    partnerId: partnerLogged && partnerLogged != null && partnerLogged.partnerId,                
                }
            } catch (e) {
                //
            }
        }

        // smart requires cpmCost and cookieDuration
        if(dmp === "smart" || dmp === "pubmatic") {
            try{
                audiencelink = {
                    ...audiencelink,
                    cpmCost: cpmCost,
                    cookieDuration: cookieDuration,
                }
            } catch (e) {
                //
            }
        }

        axios
            .post('/audiencelink', audiencelink)
            .then(response => {
                // 2 - create a new license
                //let dmpSegmentId = response.body.segmentId
                axios
                    .post('/license', {
                        audienceId,
                        dmp,
                        dmpProductId,
                        dmpClientId,
                        validUntil,
                        cookieDuration,
                        cpmCost,
                        currency,
                        countryId,
                        

                    })
                    .then(licenseResponse => {
                        let license = licenseResponse.data.body
                        let status = licenseResponse.data.status
                        let message = licenseResponse.data.messages
                        console.log('saved license ', license, 'status', status, 'message', message)

                        // same license
                        if (message && message.length > 0 && message[0].indexOf('creation: license existing with the same client id') != -1) {
                            console.log("don't save the license: we got the same dmp and audience id: ", license, 'status', status, message)
                            //Alert.success("License creation successful!")
                            //this.props.goBack()
                            return
                        }

                        this.setState({ saving: false, status: 'SUCCESS', statusMessage: 'License created successful!' })

                        //Alert.success("License creation successful!")
                        //this.props.goBack()
                    })
                    .catch(err => {
                        console.log('License creation error: ', err)
                        this.setState({ saving: false, hideModal: true, status: 'FAILURE', statusMessage: 'License creation failure' })
                    })
            })
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    {this.state.error && <LicensingErrorAlert error={this.state.error} />}
                    {this.state.phase === CONFIG_AUDIENCE && (
                        <NewLicenseHeader onCancel={this.onCancel} editMode={false} onNext={this.onGoConfigProduct} nextEnabled={!!this.state.selected} />
                    )}
                    {this.state.phase === CONFIG_AUDIENCE && (
                        <AudienceSelector
                            audiences={this.state.audiences}
                            loading={this.state.loading}
                            onLoadMore={this.onLoadMore.bind(this)}
                            selected={audience => audience === this.state.selected}
                            onSelect={audience => this.setState({ selected: audience })}
                            sort={this.state.sort}
                            sortOrder={this.state.sortOrder}
                            onSortChange={this.onSortChange.bind(this)}
                            last_page={this.props.last_page}
                            onSelect={this.onSelect.bind(this)}
                            onFilterChange={this.onFilterChange.bind(this)}
                            size={this.state.size}
                            offset={this.state.offset}
                        />
                    )}
                    {this.state.phase === CONFIG_PRODUCT && (
                        <NewLicenseConfigHeader
                            audience={this.state.selected}
                            agencyName={this.props.agencyName}
                            editMode={false}
                            onCancel={this.onCancel}
                            onNext={this.onPublish}
                        />
                    )}
                    {this.state.phase === CONFIG_PRODUCT && <SelectedAudience selected={this.state.selected} />}

                    {!this.state.hideModal && (
                        <PublishModal
                            onOK={this.props.goBack}
                            onFail={this.onFailPublish}
                            onHide={this.onHide.bind(this)}
                            saving={this.state.saving}
                            status={this.state.status}
                            statusMessage={this.state.statusMessage}
                        />
                    )}
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goBack: () => push('/licenses')
    }
)(License)
